import SuperTokens from "supertokens-auth-react";
import Session from "supertokens-auth-react/recipe/session";
import EmailPassword from "supertokens-auth-react/recipe/emailpassword";
import EmailVerification from "supertokens-auth-react/recipe/emailverification";
import axios from "axios"; // Import axios

const SUPERTOKENS_COOKIE_DOMAIN = process.env.REACT_APP_SUPERTOKENS_COOKIE_DOMAIN || undefined;
const SUPERTOKENS_COOKIE_SECURE = process.env.REACT_APP_SUPERTOKENS_COOKIE_SECURE === 'true';
const SUPERTOKENS_COOKIE_SAME_SITE = process.env.REACT_APP_SUPERTOKENS_COOKIE_SAME_SITE;

console.log("Initializing SuperTokens (USA Branch). API Domain:", process.env.REACT_APP_API_DOMAIN);

SuperTokens.init({
  style: `
    [data-supertokens~="superTokensBranding"] {
        display: none;
    }
  `,
  appInfo: {
    appName: "TShirtApp",
    apiDomain: process.env.REACT_APP_API_DOMAIN || (process.env.NODE_ENV === 'development'
      ? process.env.REACT_APP_LOCAL_API_DOMAIN
      : "https://api.yourshirt.co"),
    websiteDomain: process.env.REACT_APP_WEBSITE_DOMAIN || "https://yourshirt.co",
    apiBasePath: "/auth",
    websiteBasePath: "/auth",
  },
  recipeList: [
    EmailVerification.init({
      mode: "REQUIRED",
    }),
    EmailPassword.init({
      signInAndUpFeature: {
        signUpForm: {
          formFields: [
            {
              id: "name",
              label: "Full Name",
              placeholder: "Enter your full name",
              validate: async (value) => value.length === 0 ? "Full Name is required" : undefined,
            },
          ],
        },
      },
      resetPasswordUsingTokenFeature: {},
    }),
    Session.init({
      cookieDomain: SUPERTOKENS_COOKIE_DOMAIN,
      cookieSecure: SUPERTOKENS_COOKIE_SECURE,
      cookieSameSite: SUPERTOKENS_COOKIE_SAME_SITE,
      axios: axios, // Pass the axios instance here
    })
  ]
});